import React, { useEffect, useState } from 'react';
import { Container, Modal } from 'react-bootstrap';
import { Link, NavLink, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Logo from '../assets/images/logo-w.png';
import Alert from 'react-bootstrap/Alert';
import Loderimg from '../assets/images/loder.gif';
import cartBag from '../assets/images/cartbag.webp';
import { useFormik } from 'formik';
import OtpInput from 'react-otp-input';
import { loginsSchema } from '../schemas';
import { FaRegUser, FaHeart, FaEdit, FaTimes, FaTrash } from "react-icons/fa";
import { FaHouse, FaMagnifyingGlass, FaUser, FaCartShopping, FaCircleCheck, FaMobileButton } from "react-icons/fa6";
import { get_common, sendOTP, verifyOTP, postCartWithoutLogin, getCartLogin, postStoreCart, RemoveCart, RemoveCartCombo, AddWishlist } from '../apiservices/ApiServices';
import { useCartWishlist } from '../pages/CartWishlistContext';
import PageMeta from '../PageMeta';

import { MdGridView } from "react-icons/md";

const Header = (props) => {
    const [isNav, setNav] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [isLoadings, setLoadings] = useState(false);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [isOtp, setIsOtp] = useState(false);
    const [metaData, setMetaData] = useState(null);
    const [otp, setOtp] = useState('');
    const [resendTimer, setResendTimer] = useState(0);
    const navigate = useNavigate();
    const handleOTPChanges = (otp) => setOtp(otp);
    const [showModal, setShowModal] = useState(false);
    const [cartData, setCartData] = useState([]);
    const [calculation, setCalculation] = useState([]);
    const [relatedPro, setRelatedPro] = useState([]);
    const [cartQuantities, setCartQuantities] = useState({});
    const [removeItem, setRemoveItem] = useState([]);
    const [ismsg, setisMsg] = useState(false);
    const { cart, setCart, wishlist, isLogin, setIsLogin, isCart, setIsCart, addToCart, addToWishlist, isSearchBox, setIsSearchBox } = useCartWishlist();
    const [searchText, setSearchText] = useState('');

    const location = useLocation();
    const subPath = location.pathname.split('/').filter(Boolean);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        const query = searchParams.get('q') || '';
        setSearchText(query);
    }, [searchParams]);

    useEffect(() => {
        let page_slug;

        if (subPath.length >= 2) {
            // Last 2 segments
            page_slug = subPath.slice(-2).join('/');
        } else {
            // Only 1 segment
            page_slug = subPath[0] || '';
        }

        get_common(page_slug).then((res) => {
            try {
                setData(res.data.data);
                setMetaData(res.data.data.meta_data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        });
        if (!localStorage.getItem('userToken')) {
            setIsLogin(false);
        }
        else {
            setIsLogin(true);
        }

    }, [isLogin, wishlist, location.pathname])


    function logOut() {
        setShow(false);
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('cart');

        localStorage.removeItem("instockonly");
        localStorage.removeItem("priceRange");
        localStorage.removeItem("selectedFilters");
        localStorage.removeItem("selectedSortBy");

        navigate("/");
        window.location.reload(true);
    }

    useEffect(() => {
        if (props?.showModal) {
            setIsOtp(false);
            setModalShow(true);
        }
    }, [props?.showModal])

    const updateGetCommon = async () => {
        let page_slug;

        if (subPath.length >= 2) {
            // Last 2 segments
            page_slug = subPath.slice(-2).join('/');
        } else {
            // Only 1 segment
            page_slug = subPath[0] || '';
        }

        get_common(page_slug).then((res) => {
            try {
                setData(res.data.data);
                setMetaData(res.data.data.meta_data);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        });
    };

    const updateLoginCartAPI = async () => {
        setLoadings(true);
        try {
            const res = await getCartLogin();
            initializeQuantities(res.data.data);
            setCartData(res.data.data);
            setCalculation(res.data.calculation);
            setRelatedPro(res.data?.related_product);
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            setisMsg(true);
            if (error.response.data.message == 'Cart is empty.') {
                localStorage.removeItem('cart');
                setCartData([0]);
            }
        }
    };

    const updateCartAPI = async (updatedCart) => {
        setLoadings(true);
        try {
            const res = await postCartWithoutLogin(updatedCart);
            setCartData(res.data.data);
            setCalculation(res.data.calculation);
            setRelatedPro(res.data?.related_product);

            localStorage.setItem("cart", JSON.stringify(updatedCart));
            updateGetCommon();
            setLoadings(false);
        } catch (error) {
            setLoadings(false);
            setisMsg(true);
            if (error.response.data.message == 'Product data not found.') {
                localStorage.removeItem('cart');
                setCartData([]);
            }
        }
    };

    const postCartData = async (postdata) => {
        try {
            const res = await postStoreCart(postdata);

            localStorage.setItem("cart", JSON.stringify(res.data.data));

            let inputArray = res.data.data;
            const transformedObject = inputArray.reduce((acc, item) => {
                acc[item.sku_id] = item.quantity;
                return acc;
            }, {});

            setCartQuantities(transformedObject);
            updateLoginCartAPI();
        } catch (error) {
            console.log(error);
            props.toast.error(error.response.data.message);
            setLoadings(false);
        }
    };

    const removeCartData = async (id) => {
        try {
            const res = await RemoveCart(id);
            updateLoginCartAPI();
        } catch (error) {
            console.log(error);
        }
    };

    const handleCartUpdate = (updatedCart) => {
        const formattedCart = Object.entries(updatedCart).map(([sku_id, quantity]) => ({
            sku_id: parseInt(sku_id, 10),
            quantity
        }));

        if (localStorage.getItem('userToken')) {
            postCartData(formattedCart);
        } else {
            updateCartAPI(formattedCart);
            //props.toast.success('cart update successfully');
        }

    };

    const handleIncrement = (sku_id, qty) => {
        setLoadings(true);
        if (cartQuantities[sku_id] < qty) {
            const updatedCart = { ...cartQuantities, [sku_id]: (cartQuantities[sku_id] || 1) + 1 };
            setCartQuantities(updatedCart);
            handleCartUpdate(updatedCart);
        }
        else {
            props.toast.info(`Maximum ${qty} Quantity Reached`);
            setLoadings(false);
        }

    };

    const handleDecrement = (sku_id) => {
        setLoadings(true);
        if (cartQuantities[sku_id] === 1) {
            props.toast.info("Minimum Quantity Reached");
            setLoadings(false);
        }
        else {
            const updatedCart = { ...cartQuantities, [sku_id]: cartQuantities[sku_id] - 1 };
            setCartQuantities(updatedCart);
            handleCartUpdate(updatedCart);
        }
    };

    const handleChanges = (e, sku_id) => {
        const value = parseInt(e.target.value, 10);
        const updatedCart = { ...cartQuantities, [sku_id]: isNaN(value) || value < 1 ? 1 : value };
        setCartQuantities(updatedCart);
        handleCartUpdate(updatedCart);
    };

    const initializeQuantities = (items) => {
        const initialQuantities = {};
        items.forEach(item => {
            initialQuantities[item.sku_id] = item.cart_quantity || 1;
        });
        setCartQuantities(initialQuantities);
    };

    const postCart = async (postdata) => {
        setLoading(true);
        try {
            const res = await postCartWithoutLogin(postdata);
            setCartData(res.data.data);
            setCalculation(res.data.calculation);
            setRelatedPro(res.data?.related_product);
            setLoading(false);
            initializeQuantities(res.data.data);
            setisMsg(false);
        } catch (error) {
            setLoading(false);
            setisMsg(true);
            setCartData([]);
            setCalculation([]);
            setRelatedPro([]);

        }
    };

    const getLoginCart = async () => {
        setLoading(true);
        try {
            const res = await getCartLogin();
            setCartData(res.data.data);
            setCalculation(res.data.calculation);
            setRelatedPro(res.data?.related_product);
            setLoading(false);
            initializeQuantities(res.data.data);
            setisMsg(false);
        } catch (error) {
            setLoading(false);
            setisMsg(true);
            localStorage.removeItem('cart');
        }
    };

    const getCartsData = async () => {
        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCart(storedCart);

        if (localStorage.getItem('userToken')) {
            getLoginCart();
            setIsLogin(true);
        } else {
            setIsLogin(false);
            postCart(storedCart);
        }
    };

    useEffect(() => {
        if (localStorage.getItem('wSkuid')) {
            setTimeout(() => {
                getCartsData();
                localStorage.removeItem('wSkuid');
            }, 2000);
        }
        else {
            getCartsData();
        }
    }, []);

    useEffect(() => {
        getCartsData();
    }, [isCart, props.CartTot]);

    // "You May Also Like" -> add to cart from sidebar
    const [addingSku, setAddingSku] = useState(null);

    const handleAddRelated = async (skuid) => {
        if (addingSku) return;
        setAddingSku(skuid);

        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        const exists = storedCart.find(i => i.sku_id == skuid);
        const updatedCart = exists
            ? storedCart.map(i => i.sku_id == skuid ? { ...i, quantity: i.quantity + 1 } : i)
            : [...storedCart, { sku_id: skuid, quantity: 1 }];

        localStorage.setItem('cart', JSON.stringify(updatedCart));
        setCart(updatedCart);
        window.dispatchEvent(new Event("storage"));

        try {
            if (localStorage.getItem('userToken')) {
                await postStoreCart([{ sku_id: skuid, quantity: 1 }]);
            }
            props.toast?.success('Added to cart');
        } catch (error) {
            props.toast?.error(error.response?.data?.message || 'Unable to add to cart');
        } finally {
            setAddingSku(null);
            getCartsData();
        }
    };

    // hide related items already in cart
    const cartSkuIds = new Set((Array.isArray(cartData) ? cartData : []).map(c => String(c?.sku_id)));
    const relatedList = (Array.isArray(relatedPro) ? relatedPro : []).filter(p => !cartSkuIds.has(String(p?.sku_id)));

    const handleCheckout = () => {
        setIsCart(false);
        if (!isLogin) {
            localStorage.setItem('isProceedCheckout', true);
            localStorage.removeItem('BuyNowData');
            setModalShow(true);
        } else {
            localStorage.removeItem('BuyNowData');
            navigate("/checkout");
        }
    };

    const addToWishlists = async (skuid) => {

        setLoadings(true);
        const updatedCart = { ...cartQuantities };
        delete updatedCart[skuid];

        setCartQuantities(updatedCart);
        const formattedCart = Object.entries(updatedCart).map(([sku, quantity]) => ({
            sku_id: parseInt(sku, 10),
            quantity
        }));

        localStorage.setItem("cart", JSON.stringify(formattedCart));
        setCart(formattedCart);
        setCartData(cartData.filter(item => item.sku_id !== skuid));

        if (localStorage.getItem('userToken')) {
            removeCartData(skuid);
        } else {
            updateCartAPI(formattedCart);
        }
        addToWishlist(skuid);
        setLoadings(false);
        setShowModal(false);

    };

    const handleRemove = async (removeItem) => {
        setShowModal(false);
        setLoadings(true);

        const groupKey = removeItem?.bundle_group_key;

        const isMatch = (c) =>
            groupKey
                ? c.bundle_group_key === groupKey
                : c.sku_id === removeItem?.sku_id && !c.bundle_group_key;

        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        const removed = storedCart.filter(isMatch);
        const newCart = storedCart.filter(c => !isMatch(c));

        // drop qty only if sku not left elsewhere in cart
        const updatedQty = { ...cartQuantities };
        removed.forEach(r => {
            if (!newCart.some(c => c.sku_id === r.sku_id)) delete updatedQty[r.sku_id];
        });
        setCartQuantities(updatedQty);

        localStorage.setItem("cart", JSON.stringify(newCart));
        setCart(newCart);
        setCartData(cartData.filter(c => !isMatch(c)));

        if (localStorage.getItem('userToken')) {
            if (groupKey) {
                const proids = removeItem?.bundle_product_id;
                try {
                    const res = await RemoveCartCombo(proids, groupKey);
                    updateLoginCartAPI();
                } catch (error) {
                    console.log(error);
                }

            }
            else {
                try {
                    const ids = removed.length ? removed.map(r => r.sku_id) : [removeItem?.sku_id];
                    await Promise.all(ids.map(id => RemoveCart(id)));
                } catch (error) {
                    console.log(error);
                }
            }
            updateLoginCartAPI();
        } else {
            updateCartAPI(newCart);
        }
    };



    useEffect(() => {
        if (resendTimer <= 0) return;

        const timer = setInterval(() => {
            setResendTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [resendTimer]);

    const handleSendOtp = async (values) => {
        setLoadings(true);
        let postdata =
        {
            "mobile_no": values.mobile,
        }
        try {
            const res = await sendOTP(postdata);
            //props.toast.success(res.data.message);
            setIsOtp(true);
            setLoadings(false);
            setResendTimer(30);
            values.otp = "";
        } catch (error) {
            if (error.response.data.message == 'OTP already sent. Please wait before requesting again.') {
                setIsOtp(true);
            }
            else {
                setIsOtp(false);
            }
            setLoadings(false);
            props.toast.error(error.response.data.message);
        }
    };

    const handleVerifyOtp = async (values) => {
        setLoadings(true);
        let postdata =
        {
            "mobile_no": values.mobile,
            "otp": otp,
        }
        try {
            const res = await verifyOTP(postdata);
            localStorage.setItem('userToken', res.data.token);
            localStorage.setItem('userData', JSON.stringify(res.data.user));

            const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
            if (!storedCart?.length) {
                updateLoginCartAPI();
            }
            else {
                postCartData(storedCart);
                updateLoginCartAPI();
            }

            props.toast.success(res.data.message);

            setIsLogin(true);
            setIsOtp(false);
            setLoadings(false);
            setModalShow(false);
            setIsCart(false);

            setTimeout(() => {
                if (localStorage.getItem('isProceedCheckout')) {
                    navigate("/checkout");
                    localStorage.removeItem('isProceedCheckout');
                }
                else if (localStorage.getItem('wSkuid')) {
                    navigate("/wishlist");
                    setShowModal(false);
                }
                else {
                    window.location.reload()
                }
            }, 3000);

        } catch (error) {
            setLoadings(false);
            props.toast.error(error.response.data.message);
        }
    };

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            mobile: '',
            otp: '',
        },
        validationSchema: loginsSchema(isOtp),
        onSubmit: (values) => {
            if (isOtp) {
                handleVerifyOtp(values);
            } else {
                handleSendOtp(values);
            }
        }
    });
    const { values, errors, touched, handleBlur, handleChange, handleSubmit } = formik;

    const handleClose = () => {
        setModalShow(false);

        if (props?.showModal) {
            props?.setShowModal(false);
        }

    };

    useEffect(() => {
        if (otp.length === 6) {
            handleSubmit();
        }
    }, [otp]);


    const addWishlistsId = (skuid) => {
        localStorage.setItem('wSkuid', JSON.stringify(skuid));

        const updatedCart = { ...cartQuantities };
        delete updatedCart[skuid];

        setCartQuantities(updatedCart);
        const formattedCart = Object.entries(updatedCart).map(([sku, quantity]) => ({
            sku_id: parseInt(sku, 10),
            quantity
        }));

        localStorage.setItem("cart", JSON.stringify(formattedCart));
        setCart(formattedCart);
        setCartData(cartData.filter(item => item.sku_id !== skuid));
        updateCartAPI(formattedCart);
        setModalShow(true);
        setShowModal(false);
        setIsCart(false);
    };

    const ClearSearch = () => {
        setSearchText('');
        navigate('/search');
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter' && searchText.trim().length > 2) {
            localStorage.removeItem("instockonlys");
            localStorage.removeItem("priceRanges");
            localStorage.removeItem("selectedFilterss");
            localStorage.removeItem("selectedSortBys");

            localStorage.removeItem("instockonly");
            localStorage.removeItem("priceRange");
            localStorage.removeItem("selectedFilters");
            localStorage.removeItem("selectedSortBy");

            navigate(`/search/?q=${encodeURIComponent(searchText.trim())}`);
        }
    };


    const cartCount = React.useMemo(() => {
        const keys = new Set(
            (cart || []).map(item =>
                item.bundle_group_key
                    ? `b_${item.bundle_group_key}`
                    : `s_${item.sku_id}`
            )
        );
        return keys.size;
    }, [cart]);

    return (
        <>
            <PageMeta metaData={metaData} />

            <div className='header-topbar'>
                <Container>
                    <div className='header-topbar-box'>
                        <ul>
                            <li>
                                <p>PREMIUM SHIELD</p>
                            </li>
                            <li>
                                <p>1-Year Warranty on Premium</p>
                            </li>
                            <li>
                                <p>2 Free Replacements Included</p>
                            </li>
                        </ul>
                    </div>
                </Container>
            </div>

            <header id='header'>
                <div className='header-block'>
                    <Container>
                        <div className='header-box'>
                            <button onClick={() => setNav(!isNav)} className="menu-icon"><span></span><span></span><span></span></button>
                            <div className='logobox'>
                                <Link to={'/'}>
                                    <img src={Logo} alt='Logo' title='Logo' />
                                </Link>
                            </div>
                            <div className={isNav ? 'main-nav open' : 'main-nav'}>
                                <button onClick={() => setNav(false)} className="closenav"><FaTimes /></button>
                                <nav id='nav'>
                                    <ul>
                                        <li><NavLink to={'/'} onClick={() => setNav(false)}>Home</NavLink></li>
                                        <li><NavLink to={'/categories'} onClick={() => setNav(false)}>Categories</NavLink>

                                            {isLoading ? (
                                                <></>
                                            ) : (
                                                <ul className='megamenu'>
                                                    {data?.category_list?.map((item) => {
                                                        return (
                                                            <li key={item.id}>
                                                                <NavLink to={item.childs?.length > 0 ? `/categorie/${item.slug}` : `/product/categories/${item.slug}`} onClick={() => setNav(false)}>
                                                                    <div className='catio'>
                                                                        <img src={item.image_url} alt={item.name} title={item.name} />
                                                                    </div>
                                                                    <span>{item.name.toLowerCase()}</span>
                                                                </NavLink>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            )}
                                        </li>
                                        {/* <li><NavLink to={'/bundle-deals'} onClick={() => setNav(false)}>Bundle & Deals</NavLink></li> */}
                                        <li><NavLink to={'/about-us'} onClick={() => setNav(false)}>About Us</NavLink></li>
                                        <li><NavLink to={'/find-your-model'} onClick={() => setNav(false)}>Find Your Model</NavLink></li>
                                        <li><NavLink to={'/policys/warranty-policy'} onClick={() => setNav(false)}>Warranty</NavLink></li>
                                    </ul>
                                    {isLogin ? (
                                        <ul className='resnav'>
                                            <li><NavLink to="/profile" onClick={() => setNav(false)}>My Profile</NavLink></li>
                                            <li><NavLink to="/wishlist" onClick={() => setNav(false)}>Wishlist</NavLink></li>
                                            <li><NavLink to="/myorders" onClick={() => setNav(false)}>My Orders</NavLink></li>
                                            <li><NavLink to="/manage-addresses" onClick={() => setNav(false)}>Manage Addresses</NavLink></li>
                                            <li><Link onClick={() => { setNav(false); setShow(true); }}>Logout</Link></li>
                                        </ul>
                                    ) : (
                                        <ul className='resnav'>
                                            <li><Link onClick={() => { setNav(false); setIsOtp(false); setModalShow(true); }}><span><FaRegUser /></span>Login/Register</Link></li>
                                        </ul>
                                    )}
                                </nav>
                            </div>
                            <div className="nav-icons">
                                <ul>
                                    <li className={isSearchBox ? 'searchboxsres open' : 'searchboxsres'}>
                                        <div className="searchboxs">
                                            <FaMagnifyingGlass />
                                            <input
                                                type='search'
                                                value={searchText}
                                                placeholder="Search..."
                                                onChange={(e) => setSearchText(e.target.value)}
                                                onKeyPress={handleKeyPress}
                                            />
                                            {searchText.length > 1 && (<button className='clearsearch' onClick={ClearSearch}><FaTimes /></button>)}
                                        </div>
                                    </li>
                                    <li className='dnone rdblock'><Link onClick={() => setIsSearchBox(!isSearchBox)}><FaMagnifyingGlass /></Link></li>
                                    {isLogin ? <li><Link to={'/wishlist'}><FaHeart /><span>{data.wishlist_count}</span></Link></li> : null}
                                    <li className='resdnonemenu'><Link to="#" onClick={(e) => { e.preventDefault(); setIsCart(!isCart); }}><FaCartShopping /><span>{cartCount}</span></Link></li>
                                    <li className='resdnonemenu'>{isLogin ?
                                        <Link><FaUser /></Link> :
                                        <Link to="#" onClick={(e) => { e.preventDefault(); setIsOtp(false); setModalShow(true); }}><FaUser /></Link>
                                    }
                                        {isLogin ? (
                                            <ul className='submenu'>
                                                <li><NavLink to={'/profile'}>My Profile</NavLink></li>
                                                <li><NavLink to={'/wishlist'}>Wishlist</NavLink></li>
                                                <li><NavLink to={'/myorders'}>My Orders</NavLink></li>
                                                <li><NavLink to={'/manage-addresses'}>Manage Addresses</NavLink></li>
                                                <li><Link onClick={() => setShow(true)}>Logout</Link></li>
                                            </ul>
                                        ) : (
                                            null
                                        )}
                                    </li>
                                </ul>
                            </div>
                            <div id="overly" className={isNav ? 'open' : ''} onClick={() => setNav(!isNav)}></div>
                        </div>
                    </Container>
                </div >
            </header >

            {show ? (<>
                <Alert variant="danger" onClose={() => setShow(false)} dismissible>
                    <Alert.Heading>Are you sure want to Logout?</Alert.Heading>
                    <hr />
                    <div className='buttons'>
                        <div>
                            <button onClick={() => logOut()} className='btn btn-green'>OK</button>
                        </div>
                        <div>
                            <button onClick={() => setShow(false)} className='btn btn-red'>Cancel</button>
                        </div>
                    </div>
                </Alert>
                <div className='overly'></div>
            </>) : null}

            <Modal id="loginres" show={modalShow} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Login / Register</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='forms'>
                        <form id='addaddress' onSubmit={handleSubmit} autoComplete="off">
                            {isOtp ?
                                <div className='otp'>
                                    <div className='titles'>
                                        <p>Please enter the OTP sent to +91 {values.mobile} <button type='button' onClick={() => setIsOtp(false)} className='btn btn-io'><FaEdit /></button></p>
                                    </div>
                                    <div className='form-group otps'>
                                        <label className="label" htmlFor="otp">OTP.</label>
                                        <OtpInput
                                            value={otp}
                                            onChange={handleOTPChanges}
                                            numInputs={6}
                                            isInputNum={true}
                                            inputType='text'
                                            shouldAutoFocus={true}
                                            renderInput={(props) => <input {...props} />}
                                        />
                                        {otp.length >= 1 && otp.length <= 5 ? (
                                            <p className='errormsg'>Please Enter OTP</p>
                                        ) : null}
                                    </div>
                                    <div className="resendBox">
                                        <p>
                                            I didn't receive the code {" "}
                                            {resendTimer > 0 ? (
                                                <span>Resend OTP in {resendTimer}s</span>
                                            ) : (
                                                <button
                                                    type="button"
                                                    onClick={() => handleSendOtp(values)}
                                                    className="btn btn-link"
                                                >
                                                    Resend OTP
                                                </button>
                                            )}
                                        </p>
                                    </div>
                                    <div className='buttonbox'>
                                        {otp.length <= 3 ?
                                            <button type='button' disabled className='btn btn-green'>Verify / Login</button> :
                                            <button type='submit' className='btn btn-green'>Verify / Login</button>
                                        }
                                    </div>
                                </div>

                                :
                                <>
                                    <div className='form-group mobile'>
                                        <label className="label" htmlFor="mobile">Mobile No.</label>
                                        <div className='inputsboxs'>
                                            <span>+91</span>
                                            <input type="tel"
                                                id="mobile"
                                                name="mobile"
                                                className="form-control"
                                                autoComplete='off'
                                                value={values.mobile}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                placeholder='Enter Mobile Number'
                                            />
                                        </div>
                                        {errors.mobile && touched.mobile ? (
                                            <p className='errormsg'>{errors.mobile}</p>
                                        ) : null}
                                    </div>
                                    <div className='buttonbox'>
                                        <button type='submit' className='btn btn-green'>Request OTP</button>
                                    </div>
                                </>
                            }

                        </form>
                    </div>
                    {isLoadings ?
                        <div className='loders'>
                            <img src={Loderimg} alt='Loder' title='Loder' />
                        </div>
                        : null}
                </Modal.Body>

            </Modal>

            <div id='carts' className={isCart ? 'open' : ''}>
                <div className='cartsHeader'>
                    <h4>Your Cart {!ismsg ? `(${calculation.total_products} Items)` : 'is Empty!'}</h4>
                    <button onClick={() => setIsCart(false)} className='closed'><FaTimes /></button>
                </div>
                {!ismsg ?
                    <>
                        <div className='cartsBody'>
                            <div className='cartListbox'>
                                {cartData.map((item) => {
                                    return (
                                        <div className='cartItems' key={item.sku_id}>
                                            {item?.is_combo == 1 ?
                                                <div className='cartimgs'>
                                                    <Link to={`/bundle-deals/${item.slug}`}>
                                                        <img
                                                            src={item?.combo_thumbnail || ""}
                                                            alt={item?.name || ""}
                                                            title={item?.name || ""}
                                                        />
                                                    </Link>
                                                </div>
                                                :
                                                <>
                                                    {Array.isArray(item?.media_list) && item?.media_list.length > 0 && (
                                                        <div className='cartimgs'>
                                                            <Link to={`/product/${item.slug}`}>
                                                                <img
                                                                    src={item?.media_list[0]?.media_url || ""}
                                                                    alt={item?.name || ""}
                                                                    title={item?.name || ""}
                                                                />
                                                            </Link>
                                                        </div>
                                                    )}
                                                </>
                                            }
                                            <div className='cartContents'>
                                                {item?.is_combo == 1 ? <Link to={`/bundle-deals/${item.slug}`}><h4>{item?.name}</h4></Link>
                                                    : <Link to={`/product/${item.slug}`}><h4>{item?.name}</h4></Link>}

                                                <div className='bandModal'>
                                                    <p>{item?.brands?.name} {item?.model?.name}</p>
                                                </div>
                                                <div className='amountboxs'>
                                                    {item?.quantity === 0 ? <div className='outofstock'>Out of Stock</div> :
                                                        <div className='stock'><FaCircleCheck /> In Stock</div>
                                                    }
                                                    <span className="pprice">&#8377;{item?.price}</span>
                                                    <span className="pold">&#8377;{item?.actual_price}</span>
                                                </div>
                                                <div className='qtybox'>
                                                    {cartQuantities[item.sku_id] == 1 ?
                                                        <button className='minus' onClick={() => { setRemoveItem(item); setShowModal(true); }}><FaTrash /></button>
                                                        :
                                                        <button className='minus' onClick={() => handleDecrement(item?.sku_id)}>-</button>}
                                                    <input
                                                        type="number"
                                                        value={cartQuantities[item.sku_id] || 1}
                                                        onChange={(e) => handleChange(e, item?.sku_id)}
                                                        min="1"
                                                    />
                                                    <button className='plush' onClick={() => handleIncrement(item?.sku_id, item?.quantity)}>+</button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            {relatedList.length > 0 && (
                                <div className='cartRelated'>
                                    <h5 className='cartRelatedTitle'>You May Also Like</h5>
                                    <div className='cartRelatedList'>
                                        {relatedList.map((item) => {
                                            const needsModel = item?.product_label === 'Select Your Phone Model';
                                            const outOfStock = item?.quantity === 0;
                                            const imgUrl = item?.media_list?.[0]?.media_url || '';
                                            return (
                                                <div className='cartItems cartRelatedItem' key={item.sku_id}>
                                                    <div className='cartimgs'>
                                                        <Link to={`/product/${item.slug}`} onClick={() => setIsCart(false)}>
                                                            {imgUrl && <img src={imgUrl} alt={item?.name || ''} title={item?.name || ''} loading='lazy' />}
                                                        </Link>
                                                    </div>
                                                    <div className='cartContents'>
                                                        <Link to={`/product/${item.slug}`} onClick={() => setIsCart(false)}>
                                                            <h4>{item?.name}</h4>
                                                        </Link>
                                                        <div className='bandModal'>
                                                            <p>{item?.brands?.name} {item?.model?.name}</p>
                                                        </div>
                                                        <div className='amountboxs'>
                                                            {outOfStock ? <div className='outofstock'>Out of Stock</div> :
                                                                <div className='stock'><FaCircleCheck /> In Stock</div>
                                                            }
                                                            <span className="pprice">&#8377;{item?.price}</span>
                                                            {item?.actual_price && <span className="pold">&#8377;{item.actual_price}</span>}
                                                            {item?.discount_per > 0 && <span className='crOff'>{item.discount_per}% Off</span>}
                                                        </div>
                                                        {outOfStock ? null : needsModel ? (
                                                            <Link to={`/product/${item.slug}`} className='crBtn' onClick={() => setIsCart(false)}>Select Model</Link>
                                                        ) : (
                                                            <button
                                                                type='button'
                                                                className='crBtn'
                                                                disabled={addingSku === item.sku_id}
                                                                onClick={() => handleAddRelated(item.sku_id)}
                                                            >
                                                                {addingSku === item.sku_id ? 'Adding...' : '+ Add to Cart'}
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className='cartsFooter'>
                            <div className='totalBoxs'>
                                <h4>Total</h4>
                                <h4>{`₹${calculation.grand_total}`}</h4>
                            </div>
                            <div className='linksboxs'>
                                <Link className="btn btn-link" to={'/product'} onClick={() => setIsCart(false)}>Continue Shopping</Link>
                            </div>

                            <div className='buttons'>
                                <button className='btn btn-green  w-100' onClick={() => { setIsCart(false); handleCheckout(); }}>Proceed to Checkout</button>
                            </div>
                        </div>
                    </>
                    :
                    <div className='cartNodata'>
                        <div className='emptyMsg'>
                            <div className='imagesIcons'>
                                <img src={cartBag} alt='Cart Empty' title='Cart Empty' />
                            </div>
                            <h4>Your Cart is Empty!</h4>
                            <p>Looks like you haven't added anything to your Cart. Let's change that.</p>
                            <div className='buttons'>
                                <Link to={'/product'} onClick={() => setIsCart(false)} className='btn btn-black'>Back to shopping</Link>
                            </div>
                        </div>
                    </div>
                }
            </div>

            {
                showModal && (
                    <Modal id="altmodal" show={showModal} onHide={() => setShowModal(false)}>
                        <Modal.Body>
                            <div className='coldebuttons'>
                                <button onClick={() => setShowModal(false)}><FaTimes /></button>
                            </div>
                            <div className='modalProductInfo'>
                                {Array.isArray(removeItem?.media_list) &&
                                    removeItem.media_list.length > 0 && (
                                        <div className="prodImg">
                                            <img
                                                src={removeItem.media_list[0]?.media_url || ""}
                                                alt={removeItem?.name || ""}
                                                title={removeItem?.name || ""}
                                            />
                                        </div>
                                    )}
                                <p>{removeItem?.name}</p>
                            </div>
                            <div className='modelContentbox'>
                                <h4>Are you sure ?</h4>
                                <p>it took you so long to find item, Wishlist instead.</p>

                                <div className='buttons'>
                                    {removeItem?.bundle_product_id ? null :
                                        <div>
                                            {isLogin ?
                                                <button onClick={() => addToWishlists(removeItem?.sku_id)} className='btn btn-green'>Move to Wishlist</button>
                                                :
                                                <button onClick={() => addWishlistsId(removeItem?.sku_id)} className='btn btn-green'>Move to Wishlist</button>
                                            }
                                        </div>}
                                    <div>
                                        <button onClick={() => handleRemove(removeItem)} className='btn btn-red'>Remove</button>
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                    </Modal>
                )
            }

            <div id='mobilemenu'>
                <ul>
                    <li><NavLink to={'/'}><FaHouse /><span>Home</span></NavLink></li>
                    <li className='catM'><NavLink to={'/categories'}><MdGridView /><span>Categories</span></NavLink></li>
                    <li className='findM'><NavLink to={'/find-your-model'}><FaMobileButton /><span>Find Your Model</span></NavLink></li>
                    {isLogin ?
                        <li className='userM'><NavLink to="/profile"><FaUser /><span>My Profile</span></NavLink></li>
                        :
                        <li className='userM'><Link to="#" onClick={(e) => { e.preventDefault(); setModalShow(true); }}><FaUser /><span>Login</span></Link></li>
                    }
                    <li className='cartsM'><Link to="#" onClick={(e) => { e.preventDefault(); setIsCart(!isCart); }}><FaCartShopping /><span>Cart</span><span className='count'>{cartCount}</span></Link></li>
                </ul>
            </div>
        </>
    );
}

export default Header